import React, { useEffect, useRef } from 'react';
import { useTheme } from '@mui/material';


const drawArrowhead = (ctx, x, y, color) => {
    ctx.save();
    ctx.setLineDash([]);
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x - 6, y - 4);
    ctx.lineTo(x - 6, y + 4);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
};

const RouteLinks = ({ cellWidth, rowHeight, routeMap, rowIndexMap, rowCount }) => {
    const theme = useTheme();
    const canvasRef = useRef(null);
    const strokeColor = theme.palette.neutral.darkest;

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        const dpr = window.devicePixelRatio || 1;
        const width = canvas.offsetWidth;
        const height = rowCount * rowHeight;

        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);

        if (!routeMap?.size) return;

        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = 1.5;
        ctx.setLineDash([4, 3]);
        ctx.globalAlpha = 0.6;

        for (const flights of routeMap.values()) {
            for (let i = 0; i < flights.length - 1; i++) {
                const from = flights[i];
                const to = flights[i + 1];
                const rowFrom = rowIndexMap.get(from.id);
                const rowTo = rowIndexMap.get(to.id);
                if (rowFrom == null || rowTo == null) continue;

                const p1x = from.startSlot * cellWidth + from.duration * cellWidth;
                const p1y = rowFrom * rowHeight + rowHeight / 2;
                const p2x = to.startSlot * cellWidth;
                const p2y = rowTo * rowHeight + rowHeight / 2;

                ctx.beginPath();
                ctx.moveTo(p1x, p1y);
                ctx.bezierCurveTo(p1x + 20, p1y, p2x - 20, p2y, p2x, p2y);
                ctx.stroke();
                drawArrowhead(ctx, p2x, p2y, strokeColor);
            }
        }
    }, [cellWidth, rowHeight, rowCount, routeMap, rowIndexMap, strokeColor]);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                inset: 0,
                pointerEvents: 'none',
                width: '100%',
                height: rowCount * rowHeight,
            }}
        />
    );
};

export default React.memo(RouteLinks);
